import CheckIcon from '@mui/icons-material/Check';
import { Section, ContentContainer, StepCard, StepImage, ChecklistItem } from '../../styles';
import {
  JourneyHeading,
  JourneySubtext,
  StepsContainer,
  StepWrapper,
  StepContentWrapper,
  StepCardContent,
  JourneyStepNumber,
  JourneyStepTitle,
  JourneyDescriptionText,
  ChecklistContainer,
  JourneyChecklistText,
  CTAButtonContainer,
  JourneyExtraDataContainer,
  JourneyExtraData,
} from './styles';
import { steps } from '../../constants';
import CTAButton from '../../../../../ui/ctaButton';
import { Gapper } from '../../../../../ui/utils';
import { openSimplePracticeConsultation } from '../../../../../utils/simplePractice';

const JourneySection = () => {

  return (
    <Section>
      <ContentContainer>
        <JourneyHeading>Your Journey with Nirva</JourneyHeading>

        <JourneySubtext>
          At Nirva, everything begins with you. Here's what your first steps will look like:
        </JourneySubtext>
        <Gapper gap={73}>
          <StepsContainer>
            {steps.map((step, index) => {
              const isEven = index % 2 === 1;
              return (
                <StepWrapper key={step.number}>
                  <StepCard>
                    <StepCardContent isEven={isEven}>
                      <StepImage src={step.image} alt={step.title} loading="lazy" />
                      <StepContentWrapper isEven={isEven}>
                        <JourneyStepNumber>{`STEP #${step.number}.`}</JourneyStepNumber>

                        <JourneyStepTitle>{step.title}</JourneyStepTitle>

                        <JourneyDescriptionText $hasSubtitle={!!step.subtitle}>
                          {step.description}
                        </JourneyDescriptionText>

                        {step.subtitle && (
                          <JourneyDescriptionText>{step.subtitle}</JourneyDescriptionText>
                        )}

                        <ChecklistContainer>
                          {step.checklist.map((item, idx) => (
                            <ChecklistItem key={idx}>
                              <CheckIcon />
                              <JourneyChecklistText>{item}</JourneyChecklistText>
                            </ChecklistItem>
                          ))}
                        </ChecklistContainer>
                        <JourneyExtraDataContainer>
                          {step.extraData &&
                            step.extraData.map((data) => (
                              <JourneyExtraData key={data.text}>
                                <img src={data.icon} alt={data.text} />
                                {data.text}
                              </JourneyExtraData>
                            ))}
                        </JourneyExtraDataContainer>
                      </StepContentWrapper>
                    </StepCardContent>
                  </StepCard>
                </StepWrapper>
              );
            })}
          </StepsContainer>
          <CTAButtonContainer>
            <CTAButton
              variant="contained"
              text="Request a Free 30-Minute Consultation"
              onClick={openSimplePracticeConsultation}
            />
          </CTAButtonContainer>
        </Gapper>
      </ContentContainer>
    </Section>
  );
};

export default JourneySection;
